/**
 * [INPUT]: 依赖 React 类组件错误边界与 children
 * [OUTPUT]: 对外提供 ErrorBoundary 全应用渲染故障恢复组件
 * [POS]: app 的最后防线，防止单个异常把页面退化为空白屏
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { Component, type ErrorInfo, type ReactNode } from 'react'

import { ErrorState } from '@/components/States'

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // 公开站点不收集分析数据；浏览器开发工具仍保留 React 的原始错误。
  }

  override render() {
    if (this.state.error)
      return (
        <div className="page">
          <ErrorState error={this.state.error} onRetry={() => this.setState({ error: null })} />
        </div>
      )
    return this.props.children
  }
}
